import { render, staticRenderFns } from "./LanguageGrid.vue?vue&type=template&id=13f4bf23&scoped=true&"
import script from "./LanguageGrid.vue?vue&type=script&lang=ts&"
export * from "./LanguageGrid.vue?vue&type=script&lang=ts&"
import style0 from "./LanguageGrid.vue?vue&type=style&index=0&id=13f4bf23&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f4bf23",
  null
  
)

export default component.exports